import { useState } from "react";
import { formatNumberWithCommas } from "functions";
import { peopleSvg, resBookSvg } from "svg";

function formatBestDate(dateStr, opts = {}) {
  if (!dateStr) return "—";
  const [year, month, day] = dateStr.split("-").map(Number);
  const d = new Date(Date.UTC(year, month - 1, day));
  return d.toLocaleDateString("en-US", {
    weekday: opts.long ? "long" : "short",
    month: opts.long ? "long" : "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}

function BestDaySide({ label, primaryValue, primaryUnit, secondaryValue, secondaryUnit, date, accent, onClick }) {
  return (
    <button type="button" className="best-day-side" onClick={onClick}>
      <div className="best-day-category">{label}</div>

      <div className="best-day-primary">
        <span className="best-day-record-num" style={accent ? { color: accent } : undefined}>
          {primaryValue != null ? formatNumberWithCommas(primaryValue) : "—"}
        </span>
        <span className="best-day-record-unit">{primaryUnit}</span>
      </div>

      <div className="best-day-meta-row">
        <span className="best-day-record-date">{date}</span>
        {secondaryValue != null && (
          <span className="best-day-secondary-pill">
            {secondaryUnit === "guests" ? peopleSvg() : resBookSvg()}
            {formatNumberWithCommas(secondaryValue)}
            <span className="best-day-secondary-pill-label">{secondaryUnit}</span>
          </span>
        )}
      </div>

      <span className="best-day-view-all">View top 10 →</span>
    </button>
  );
}

function PeakModal({ title, items, primaryKey, secondaryKey, primaryLabel, secondaryLabel, accent, onClose }) {
  return (
    <div className="popup-wrapper" onClick={onClose}>
      <div className="popup peak-modal" onClick={(e) => e.stopPropagation()}>
        <div className="peak-modal-header">
          <div>
            <div className="peak-modal-eyebrow">Top 10</div>
            <div className="peak-modal-title">{title}</div>
          </div>
          <button className="gc-modal-close" onClick={onClose}>✕</button>
        </div>

        {items.length === 0 ? (
          <div className="peak-modal-empty">No reservation data yet.</div>
        ) : (
          <ol className="peak-modal-list">
            {items.map((item, i) => (
              <li key={item.date} className="peak-modal-row">
                <span className="peak-modal-rank">{i + 1}</span>
                <div className="peak-modal-date">{formatBestDate(item.date, { long: true })}</div>
                <span className="peak-modal-primary" style={accent ? { color: accent } : undefined}>
                  {formatNumberWithCommas(item[primaryKey])}
                  <span className="peak-modal-unit">{primaryLabel}</span>
                </span>
                <span className="peak-modal-secondary">
                  {formatNumberWithCommas(item[secondaryKey])}
                  <span className="peak-modal-unit">{secondaryLabel}</span>
                </span>
                <span className="peak-modal-waitlist">
                  {formatNumberWithCommas(item.fromWaitlist || 0)}
                  <span className="peak-modal-unit">from waitlist</span>
                </span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}

function BestDay({ bestDays }) {
  const byCountTop = bestDays?.byCount?.top || [];
  const byGuestsTop = bestDays?.byGuests?.top || [];
  const topCount = byCountTop[0];
  const topGuests = byGuestsTop[0];

  const [openModal, setOpenModal] = useState(null);

  return (
    <>
      <div className="best-day-widget" style={{ gridColumn: "1 / 3", gridRow: 1 }}>
        <BestDaySide
          label="Peak Reservations"
          primaryValue={topCount?.count}
          primaryUnit="reservations"
          secondaryValue={topCount?.guests}
          secondaryUnit="guests"
          date={formatBestDate(topCount?.date)}
          accent="var(--ad-gold)"
          onClick={() => byCountTop.length && setOpenModal("count")}
        />
        <div className="best-day-divider" />
        <BestDaySide
          label="Peak Guests"
          primaryValue={topGuests?.guests}
          primaryUnit="guests"
          secondaryValue={topGuests?.count}
          secondaryUnit="reservations"
          date={formatBestDate(topGuests?.date)}
          accent="var(--ad-gold)"
          onClick={() => byGuestsTop.length && setOpenModal("guests")}
        />
      </div>

      {openModal === "count" && (
        <PeakModal
          title="Peak Reservation Days"
          items={byCountTop}
          primaryKey="count"
          secondaryKey="guests"
          primaryLabel="reservations"
          secondaryLabel="guests"
          accent="var(--ad-gold)"
          onClose={() => setOpenModal(null)}
        />
      )}

      {openModal === "guests" && (
        <PeakModal
          title="Peak Guest Days"
          items={byGuestsTop}
          primaryKey="guests"
          secondaryKey="count"
          primaryLabel="guests"
          secondaryLabel="reservations"
          accent="var(--ad-gold)"
          onClose={() => setOpenModal(null)}
        />
      )}
    </>
  );
}

export default BestDay;
